// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ArticleCollectionVO, ArticleVO } from '@article/model/vo/article.vo';
import { ManageAccessoriesComponent } from '../accessory/manage-accessories/manage-accessories.component';
import { CopyPropertiesModalComponent } from '../article/copy-properties-modal/copy-properties-modal.component';
import { ManageEndPlatesComponent } from '../article/endplate/manage-end-plates/manage-end-plates.component';
import { ManagePropertiesDefComponent } from '../property/manage-properties-def/manage-properties-def.component';
import { EditArticleNumberMappingComponent } from '@article/components/custom-article-number/edit-article-number-mapping/edit-article-number-mapping.component';
import { WindowService } from '@shared/window/window.service';
import { ArticleNumberMappingListVO, ArticleNumberMappingVO } from '@article/model/vo/article-number-mapping.vo';
import { EditCustomArticleNumberComponent } from '@article/components/custom-article-number/edit-custom-article-number/edit-custom-article-number.component';
import { EditCustomArticleNumberListComponent } from '@article/components/custom-article-number/edit-custom-article-number-list/edit-custom-article-number-list.component';
import { ArticleAccessoryEntryVO } from '@article/model/vo/article-accessory-info-vo';
import { AddAccessoryComponent } from '@article/components/accessories/add-accessory/add-accessory.component';
import { EditAccessoryComponent } from '@article/components/accessories/edit-accessory/edit-accessory.component';
import { InvalidArticleNumberMappingImportEntriesComponent } from '@article/components/custom-article-number/edit-article-number-mapping/invalid-article-number-mapping-import-entries.component';
import { DataCenterExportComponent } from '@article/components/data-center-export/data-center-export.component';
import { TechnicalInfoPropertiesComponent } from '../article/technical-info-properties/technical-info-properties.component';
import { ArticleWithTechnicalPropertiesDTO } from '@article/properties/technical/technical-requirements';

@Injectable({ providedIn: 'root' })
export class ArticleComponentsPresenter {

  constructor(private windowService: WindowService) {
  }

  public presentManageAccessoriesComponent(articleId: number): void {
    this.windowService.showModal(ManageAccessoriesComponent, {
      class: `modal-md`,
      initialState: { articleId },
    });
  }

  public presentManageEndPlatesComponent(articleNo: string): void {
    this.windowService.showModal(ManageEndPlatesComponent, {
      class: `modal-md`,
      initialState: { articleNo },
    });
  }

  public presentTechnicalInfoPropertiesComponent(articleId: number): void {
    this.windowService.showModalFinish(TechnicalInfoPropertiesComponent, { class: 'modal-lg', initialState:  { articleId } });
  }

  public presentManagePropertiesDefComponent(): void {
    this.windowService.showModal(ManagePropertiesDefComponent, {
      class: 'modal-md',
    });
  }

  public openCopyPropertiesDialog(targetArticleVO: ArticleVO, sourceArticleVO: ArticleVO) {
    this.windowService.showModal(CopyPropertiesModalComponent, {
      class: 'modal-lg',
      initialState: {
        targetArticleVO,
        sourceArticleVO,
      },
    });
  }

  public openEditArticleNumberMappingDialog(editedCollection?: ArticleCollectionVO): void {
    this.windowService.showModal(EditArticleNumberMappingComponent, {
      class: 'modal-d-block', // for fix empty space in bottom of dialog in IE
      initialState: {editedCollection},
    });
  }

  public openAddCustomArticleNumberDialog(createdMappings: ArticleNumberMappingVO[], articleNumberMapping: ArticleNumberMappingVO = null): Promise<ArticleNumberMappingVO | undefined> {
    return this.windowService.showModalFinish(EditCustomArticleNumberComponent, {
      initialState: {createdMappings, articleNumberMapping},
    });
  }

  public openAddCustomArticleNumberListDialog(): Promise<ArticleNumberMappingListVO | null> {
    return this.windowService.showModalFinish(EditCustomArticleNumberListComponent);
  }

  public openAddAccessoryPopup(): Promise<ArticleAccessoryEntryVO> {
    return this.windowService.showModalFinish(AddAccessoryComponent, {
      class: `modal-md`,
    });
  }

  public openEditAccessoryPopup(accessory: ArticleAccessoryEntryVO): Promise<number> {
    return this.windowService.showModalFinish(EditAccessoryComponent, {
      class: `modal-md`,
      initialState: {accessory},
    });
  }

  public openInvalidArticleNumberMappingImportRecordsPopup(invalidMappings: ArticleNumberMappingVO[]): void {
    this.windowService.showModal(InvalidArticleNumberMappingImportEntriesComponent, {
      class: `modal-md`,
      initialState: {invalidMappings},
    });
  }

  public openCompactDataDownloadDialog(articles: (ArticleVO | ArticleWithTechnicalPropertiesDTO)[]): void {
    this.windowService.showModal(DataCenterExportComponent, {
      class: 'modal-lg',
      initialState: {articles},
    });
  }
}
